import { connect } from 'react-redux';
import SectionWidget from './SectionWidget';

const mapStateToProps = (state, props) => {
  const configState = props.actions.config.getLocalState(state);
  const sectionState = props.actions.section.getLocalState(state);
  return {
    waitingListEnabled: configState.configuration && configState.configuration.waitingListEnabled,
    section: sectionState,
    config: configState,
    configError: configState.ERROR,
    configErrorCode: configState.ERROR_CODE,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  function load() {
    dispatch(props.actions.section.load(this.config, props.sectionCode));
  }
  function logError(errorCode, error, info) {
    dispatch(props.actions.config.logError(errorCode, error, info));
  }
  return {
    load,
    logError,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SectionWidget);
